/* eslint-disable id-length */
// eslint-disable-next-line import/no-extraneous-dependencies
import sanitizeHtml from "sanitize-html";

const clean = (dirty) => sanitizeHtml(dirty, {
    allowedTags: ["b", "i", "em", "strong", "a", "iframe", "img", "div", "h1", "span", "p"],
    allowedAttributes: {
        // eslint-disable-next-line id-length
        a: ["href"],
        iframe: ["src", "width", "height", "frameborder", "allow", "allowfullscreen", "style", "title"],
        img: ["src", "alt", "title", "width", "height", "style", "sizes", "onclick"],
        div: ["class", "style"],
        span: ["class", "style"],
    },
    transformTags: {
        a(tagName, attribs) {
            if ((attribs.href && attribs.href.indexOf("http://my.sealskincovers.com") === 0) || attribs.href.indexOf("https://sealskincovers.com") === 0) {
                // Return the anchor tag with the allowed 'href' attribute
                return {
                    tagName,
                    attribs: { href: attribs.href },
                };
            } 
            // If the 'href' is not allowed, return without the 'href' attribute
            return {
                tagName,
                attribs: {},
            };
        },
    },
    allowedIframeHostnames: ["www.youtube.com", "calendar.google.com, my.sealskincovers.com"],
});

export default clean;
